// OAuth Identity Provider Configuration
// These IDs correspond to the Identity Provider IDs configured in FusionAuth

export const OAUTH_CONFIG = {
  FUSIONAUTH_URL: 'https://auth.lumi.education',
  APPLICATION_ID: import.meta.env.VITE_FA_APPLICATION_ID || '8451337a-d4de-4cba-afe3-d6d17150a06d',
  CLIENT_CALLBACK_URL: import.meta.env.VITE_CLIENT_URL || 'https://app.lumi.education',

  IDENTITY_PROVIDERS: {
    GOOGLE: '82339786-3dff-42a6-aac6-1f1ceecb6c46',
    GITHUB: 'a4879379-97ed-4a2f-a7cb-0b6d31a04ad7',
    APPLE: '13d2a5db-7ef9-4d62-b909-0df58612e775',
    MICROSOFT: '85607de5-b55a-4299-93d7-9056b7e460bc',
    EDUPLACES: '413d6999-37d6-41de-8108-fedbf0242f60',
  },
} as const;

export type IdentityProvider = keyof typeof OAUTH_CONFIG.IDENTITY_PROVIDERS;
